import { useEffect, useRef, useState } from 'react'

// Height available to an antd Table body (`scroll.y`) so the whole table fits
// inside the element the returned `ref` is attached to. That element must get
// its height from the layout (e.g. `flex: 1; min-height: 0`), not from the table.
const useTableScrollY = (deps = []) => {
  const ref = useRef(null)
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    let raf = null
    const update = () => {
      const headerEl = el.querySelector('.ant-table-thead')
      const headerH = headerEl ? headerEl.getBoundingClientRect().height : 40
      const bodyH = Math.max(el.clientHeight - headerH - 2, 0)
      setScrollY((prev) => (Math.abs(prev - bodyH) < 1 ? prev : bodyH))
    }
    update()
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(update)
    })
    observer.observe(el)
    return () => {
      observer.disconnect()
      cancelAnimationFrame(raf)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return [ref, scrollY]
}

export const tableAreaStyle = { flex: 1, minHeight: 0, overflow: 'hidden' }

export const emptyStateStyle = (scrollY) => ({
  minHeight: scrollY > 0 ? scrollY - 9 : undefined,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px',
})

export default useTableScrollY
